import { StandardsModalTabs } from "./StandardsModalTabs";

export { StandardsModalTabs };
